"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _slate = require("slate");

var _slateEditCode = _interopRequireDefault(require("slate-edit-code"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(codeOption, currentTextNode, matched, change, lang) {
  var matchedLength = matched[0].length;
  var codePlugin = (0, _slateEditCode.default)(codeOption);
  var newChange = change;

  if (lang) {
    newChange = change.setBlocks({
      data: _slate.Data.create({
        syntax: lang
      })
    });
  }

  return codePlugin.changes.wrapCodeBlock(newChange.deleteAtRange(_slate.Range.create({
    anchorKey: currentTextNode.key,
    focusKey: currentTextNode.key,
    anchorOffset: matched.index,
    focusOffset: matched.index + matchedLength
  })));
}